export const ACQUISITION_CHANNEL = {
  SENIOR_HANDOVER: 'SENIOR_HANDOVER',
  SAME_SCHOOL: 'SAME_SCHOOL',
  OTHER_SCHOOL: 'OTHER_SCHOOL',
  ORDER_EXPERIENCE: 'ORDER_EXPERIENCE',
  EVERYTIME_PROMOTION: 'EVERYTIME_PROMOTION',
  INSTAGRAM: 'INSTAGRAM',
  SEARCH: 'SEARCH',
  ETC: 'ETC',
} as const;

export type AcquisitionChannel = typeof ACQUISITION_CHANNEL[keyof typeof ACQUISITION_CHANNEL];

export const ACQUISITION_CHANNEL_LABEL: Record<AcquisitionChannel, string> = {
  [ACQUISITION_CHANNEL.SENIOR_HANDOVER]: '전임 학생회·선배 추천',
  [ACQUISITION_CHANNEL.SAME_SCHOOL]: '같은 학교 다른 학과·동아리',
  [ACQUISITION_CHANNEL.OTHER_SCHOOL]: '다른 학교 사례를 보고',
  [ACQUISITION_CHANNEL.ORDER_EXPERIENCE]: '손님으로서 써보고 알게 됨',
  [ACQUISITION_CHANNEL.EVERYTIME_PROMOTION]: '에브리타임 홍보글',
  [ACQUISITION_CHANNEL.INSTAGRAM]: '인스타그램',
  [ACQUISITION_CHANNEL.SEARCH]: '검색 (네이버·구글)',
  [ACQUISITION_CHANNEL.ETC]: '기타',
};

export const ACQUISITION_CHANNEL_ORDER: AcquisitionChannel[] = [
  ACQUISITION_CHANNEL.SENIOR_HANDOVER,
  ACQUISITION_CHANNEL.SAME_SCHOOL,
  ACQUISITION_CHANNEL.OTHER_SCHOOL,
  ACQUISITION_CHANNEL.ORDER_EXPERIENCE,
  ACQUISITION_CHANNEL.EVERYTIME_PROMOTION,
  ACQUISITION_CHANNEL.INSTAGRAM,
  ACQUISITION_CHANNEL.SEARCH,
  ACQUISITION_CHANNEL.ETC,
];

export const ACQUISITION_CHANNEL_ETC_MAX_LENGTH = 100;
